exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable td[data-v-e498b8ca]:not([align]), table th[data-v-e498b8ca]:not([align]) {\n  text-align: center;\n}\ntable[data-v-e498b8ca] {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0 auto;\n  display: block;\n  height: 500px;\n  table-layout: fixed;\n}\ntd[data-v-e498b8ca], th[data-v-e498b8ca] {\n  min-width: 100px;\n  padding: 8px;\n  margin: auto;\n  max-width: 350px;\n  font-size: smaller;\n}\ntd[data-v-e498b8ca] {\n  text-align: left;\n  padding: 8px;\n}\nth[data-v-e498b8ca] {\n  background: #ffeeff;\n  white-space: nowrap;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 10000;\n  vertical-align: middle;\n}\ntable tr[data-v-e498b8ca]:nth-child(odd) {\n  background: #ffeeff;\n}\ntable tr[data-v-e498b8ca]:nth-child(even) {\n  background: #fafafa;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e498b8ca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/Manage/ModalActionTable.vue
// module id = XheL
// module chunks = 0